import { Link } from "react-router-dom";
import { useRouteError, isRouteErrorResponse } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  let errorStatus: string | number = "";
  if (isRouteErrorResponse(error)) {
    errorStatus = error.status;
  }

  return (
    <>
      <div className="weui-msg">
        <div className="weui-msg__icon-area">
          <i className="weui-icon-warn weui-icon_msg"></i>
        </div>
        <div className="weui-msg__text-area">
          <h2 className="weui-msg__title">{errorStatus}</h2>
          <p className="weui-msg__desc">
            {errorStatus === 404
              ? "找不到此页面, 此页面可能已过期, 你需要返回首页吗?"
              : "出现错误"}
          </p>
        </div>
        <div className="weui-msg__tips-area">
          <p className="weui-msg__tips">
            {/* 提示详情，可根据实际需要安排，如果换行则不超过规定长度，居中展现
          <a className="weui-wa-hotarea weui-link" href="javascript:">
            文字链接
          </a> */}
          </p>
        </div>
        <div className="weui-msg__opr-area">
          <p className="weui-btn-area">
            <Link to="/" className="weui-btn weui-btn_primary">
              返回首页
            </Link>
          </p>
        </div>
        <div className="weui-msg__extra-area">
          <div className="weui-footer">
            <p className="weui-footer__links">
              <Link to="/" className="weui-wa-hotarea weui-footer__link">
                首页
              </Link>
            </p>
            <p className="weui-footer__text">Copyright &copy; 2024 小助手</p>
          </div>
        </div>
      </div>
    </>
  );
}
